import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {AccessService} from "../../services/access.service";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {RouterLink} from "@angular/router";
import {DatePipe, NgIf} from "@angular/common";
import {YesNoPipe} from "../../pipes/yes-no.pipe";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-user-list',
    imports: [PaginationComponent, RouterLink, NgIf, YesNoPipe, FormsModule, DatePipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-users me-2"></i>Benutzer <small class="text-muted">({{totalEntries}})</small></h3>
                </div>

                <button type="button" class="btn btn-primary mb-3" [routerLink]="['/user', 0]">Benutzer anlegen</button>

                <pagination
                    [hidden]="entries?.length == 0"
                    [totalItems]="totalEntries"
                    [itemsPerPage]="paginConfig.itemsPerPage"
                    [(ngModel)]="paginConfig.page"
                    (pageChanged)="listEntries($event)"
                    [maxSize]="20"
                    previousText="Letzte"
                    nextText="Nächste">
                </pagination>

                <div class="table-responsive">
                    <table *ngIf="entries?.length > 0" class="table table-striped table-hover pointer mb-0">
                        <thead>
                        <tr>
                            <th style="width: 100px" (click)="setOrder('firstname')">
                                Vorname <i class="fa-solid" *ngIf="predicate == 'firstname'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('lastname')">
                                Nachname <i class="fa-solid" *ngIf="predicate == 'lastname'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('daily_report')">
                                Täglicher Bericht <i class="fa-solid" *ngIf="predicate == 'daily_report'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('monthly_report')">
                                Monatlicher Bericht <i class="fa-solid" *ngIf="predicate == 'monthly_report'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('active')">
                                Aktiv <i class="fa-solid" *ngIf="predicate == 'active'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('last_activity')">
                                Letzte Aktivität <i class="fa-solid" *ngIf="predicate == 'last_activity'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        @for (entry of entries; track entry.id) {
                            <tr [routerLink]="['/user', entry.id]">
                                <td>{{ entry.firstname }}</td>
                                <td>{{ entry.lastname }}</td>
                                <td>{{ entry.daily_report | yesNo }}</td>
                                <td>{{ entry.monthly_report | yesNo }}</td>
                                <td>{{ entry.active | yesNo }}</td>
                                <td>{{ entry.last_activity | date: 'dd.MM.yyyy HH:mm' }}</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `
})
export class UserListComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);

    paginConfig: any = {
        itemsPerPage: 25,
        page: 1,
    };
    entries!: any[]|null;
    totalEntries = 0;
    predicate = 'lastname';
    search: any = {
        text: '',
    };
    reverse: boolean = false;

    ngOnInit(): void {
        this.listEntries(this.paginConfig);
    }

    setOrder(order: string): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event: any): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('User/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.users;
            this.entries.forEach(entry => {
                entry.active = entry.active === 1;
                entry.daily_report = entry.daily_report === 1;
                entry.monthly_report = entry.monthly_report === 1;
            });
        });
    }

}
